// extracted by mini-css-extract-plugin
export var bodyRow = "_gg-d";
export var cardColumns = "_gg-e";
export var ellipsesOverflow = "_gg-2";
export var flatBottomCorners = "_gg-3";
export var flatTopCorners = "_gg-4";
export var headerActionsDropdown = "_gg-f";
export var headerBottomRow = "_gg-c";
export var headerTopRow = "_gg-b";
export var orderDetailsWrapper = "_gg-0";
export var orderInfoContainer = "_gg-1";
export var productDetails = "_gg-9";
export var productImage = "_gg-5";
export var responsiveTable = "_gg-8";
export var shipmentContainer = "_gg-a";
export var tableBottomLeft = "_gg-6";
export var tableBottomRight = "_gg-7";
export var trackingLink = "_gg-g";